(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ara-categorySlider"] && !window.DesignMode) return;
  try {
    
  let mySwiper = null;
  const mediaQuery = window.matchMedia('(max-width: 769px)');

  const checkBreakpoint = (e) => {
    if (e.matches) {
      initSwiper();
    } else if (mySwiper) {
      mySwiper.destroy(false, true);
    }
  }

  const initSwiper = () => {
    mySwiper = new Swiper('.categorySwiper .swiper', {
      slidesPerView: 1.5,
      spaceBetween: 1,
      speed: 1000,
      pagination: {
        el: '.categorySwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: ".categorySwiper .swiper-button-next",
        prevEl: ".categorySwiper .swiper-button-prev",
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        }
      },
    });
  };

  mediaQuery.addListener(checkBreakpoint);
  checkBreakpoint(mediaQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-footer__store"] && !window.DesignMode) return;
  try {
    
  // フッター　アコーディオン
  $(window).resize(function() {
    if (window.matchMedia("(max-width: 767px)").matches) {
  	  $('.top__nav__title').addClass('footer__accordion__toogle');
    } else {
  	  $('.top__nav__title').removeClass('footer__accordion__toogle');
    };
  });
  
  $('.top__nav__title').click(function(){
    $(this).next().slideToggle(150);
    $(this).toggleClass('open');
  });
  
  // カレンダー JavaScript
  const date = new Date();
  const today = date.getDate();
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();
  const monthHeader = document.querySelector("#month");
  const yearHeader = document.querySelector("#year");

  function createCalendar(month) {
      const monthDays = ["日", "月", "火", "水", "木", "金", "土"];

      monthHeader.innerHTML = `${currentMonth + 1}<span class="month__text">月</span>`;
      yearHeader.innerHTML = `${currentYear}`;
    
      let calendarHTML = '<table class="calendar"><thead><tr>';
  
      for (let i = 0; i < 7; i++) {
          if (i === 0) {
              calendarHTML += `<th class="sun">${monthDays[i]}</th>`;
          } else if (i === 6) {
              calendarHTML += `<th class="sat">${monthDays[i]}</th>`;
          } else {
              calendarHTML += `<th>${monthDays[i]}</th>`;
          }
      }
  
      calendarHTML += '</tr></thead><tbody>';
  
      const daysInMonth = new Date(date.getFullYear(), month + 1, 0).getDate();
      const firstDay = new Date(date.getFullYear(), month, 1).getDay();
  
      const daysInPrevMonth = new Date(date.getFullYear(), month, 0).getDate();
  
      let dayCount = 1;
      let prevDayCount = daysInPrevMonth - firstDay + 1;
  
      for (let i = 0; i < 6; i++) {
          calendarHTML += '<tr>';
  
          for (let j = 0; j < 7; j++) {
              if (i === 0 && j < firstDay) {
                  calendarHTML += `<td class="mute">${prevDayCount}</td>`;
                  prevDayCount++;
              } else if (dayCount > daysInMonth) {
                  let nextMonthDayCount = dayCount - daysInMonth;
                  calendarHTML += `<td class="mute">${nextMonthDayCount}</td>`;
                  dayCount++;
              } else {
                  // 今日の日付にclassを付ける
                  if (dayCount === today && month === currentMonth) {
                      calendarHTML += `<td class="today">${dayCount}</td>`;
                  } 
                  // 日曜日にclassを付ける
                  // else if (j === 0) {
                  //     calendarHTML += `<td class="off">${dayCount}</td>`;
                  // } 
                  else {
                      calendarHTML += `<td>${dayCount}</td>`;
                  }
                  dayCount++;
              }
          }
  
          calendarHTML += '</tr>';
  
          if (dayCount - daysInMonth > 7) {
              break;
          }
      }
  
      calendarHTML += '</tbody></table>';
  
      return calendarHTML;
  }
  
  document.getElementById('calendar').innerHTML = createCalendar(currentMonth);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-header"] && !window.DesignMode) return;
  try {
    
  $('.side__trigger').click(
    function(){
    $('.l-header').toggleClass('open');
    $('html, body').toggleClass('u-overflow__hidden');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-header__store"] && !window.DesignMode) return;
  try {
    
  // ヘッダースクロールで固定
  $(window).scroll(function () {
    if($(window).scrollTop() > 40) {
      $('.ara__header').addClass('fixed');
      $('body').addClass('marginTop');
    } else {
      $('.ara__header').removeClass('fixed');
      $('body').removeClass('marginTop');
    }
  });
  // アコーディオン
  $('.accordion__toogle').click(function(){
    $(this).next().slideToggle(150);
    $(this).toggleClass('open');
    $('.accordion__toogle').not($(this)).next().slideUp(0);
    $('.accordion__toogle').not($(this)).removeClass('open');
  });
  // ハンバーガー
  $('.ico__hamburger').click(function(){
    $(this).addClass('open');
    $('#overlay').addClass('open');
    $('.drawer').addClass('open');
    $('html, body').addClass('overflow__hidden');
  });
  $('#overlay').click(function(){
    $(this).removeClass('open');
    $('.ico__hamburger').removeClass('open');
    $('.drawer').removeClass('open');
    $('html, body').removeClass('overflow__hidden');
  });
  $('.drawer__close').click(function(){
    $('.drawer').removeClass('open');
    $('.ico__hamburger').removeClass('open');
    $('#overlay').removeClass('open');
    $('html, body').removeClass('overflow__hidden');
  });
  // ハンバーガーメニュー内ドロワー　アコーディオン
  $('.drawer__nav__accordion__toogle').click(function(){
    $(this).next().slideToggle(150);
    $(this).toggleClass('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-mainSlider"] && !window.DesignMode) return;
  try {
    
  const mainSwiper = new Swiper('.mainSwiper .swiper', {
    spaceBetween: 0,
    slidesPerGroup: 1,
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      waitForTransition: false,
      delay: 4000,
    },
    // ページネーション
    pagination: {
      el: '.mainSwiper .swiper-pagination-card',
      clickable: true,
    },
    navigation: {
      nextEl: ".mainSwiper .swiper-button-next",
      prevEl: ".mainSwiper .swiper-button-prev",
    },
    loop: true,
    breakpoints: {
      770: {
        spaceBetween: 10,
        slidesPerView: 3,
      }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-manufacturerSwiper"] && !window.DesignMode) return;
  try {
    
  let mySwiper = null;
  const mediaQuery = window.matchMedia('(max-width: 769px)');

  const checkBreakpoint = (e) => {
    if (e.matches) {
      initSwiper();
    } else if (mySwiper) {
      mySwiper.destroy(false, true);
    }
  }

  const initSwiper = () => {
    mySwiper = new Swiper('.manufacturerSwiper .swiper', {
      slidesPerView: 1.5,
      spaceBetween: 1,
      speed: 1000,
      pagination: {
        el: '.manufacturerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: ".manufacturerSwiper .swiper-button-next",
        prevEl: ".manufacturerSwiper .swiper-button-prev",
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        }
      },
    });
  };

  mediaQuery.addListener(checkBreakpoint);
  checkBreakpoint(mediaQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-productSlider"] && !window.DesignMode) return;
  try {
    
  const swiper = new Swiper('.productSwiper .swiper', {
    spaceBetween: 4,
    slidesPerView: 1,
    slidesPerGroup: 1,
    speed: 1000,
    pagination: {
      el: '.productSwiper .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".productSwiper .swiper-button-next",
      prevEl: ".productSwiper .swiper-button-prev",
    },
    breakpoints: {
      450: {
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup: 2,
        speed: 500,
      },
      770: {
        spaceBetween: 25,
        slidesPerView: 4,
        slidesPerGroup: 4,
        speed: 300,
      }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-card_r2k"] && !window.DesignMode) return;
  try {
    
  const R2Kthumb = document.querySelectorAll('#business__r2k__slide .thumb-media');

  const R2KswitchThumb = (index) => {
    document.querySelector('#business__r2k__slide .thumb-media-active').classList.remove('thumb-media-active');
    R2Kthumb[index].classList.add('thumb-media-active');
  }
  const R2KSwiper = new Swiper('#business__r2k__slide .business__slider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 700,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    followFinger: false,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-card_value"] && !window.DesignMode) return;
  try {
    
  const ValueSwiper = new Swiper('#business__value__slide .swiper', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 700,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    followFinger: false,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  const agreeCheckbox = document.getElementById("agree");
  const submitBtn = document.getElementById("submit-btn");
  agreeCheckbox.addEventListener("click", () => {
    if (agreeCheckbox.checked === true) {
      submitBtn.disabled = false; 
    }
    else {
      submitBtn.disabled = true; 
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main__product"] && !window.DesignMode) return;
  try {
    
  // サムネイル
  const mainProductThumbnail = new Swiper(".main__product__media .slider-thumbnail", {
    slidesPerView: 4,
    spaceBetween: 5,
    grabCursor: true,
    scrollbar: {
      el: '.main__product__media .swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      660: {
        slidesPerView: 5,
      },
      960: {
        slidesPerView: 6,
      },
    },
  });
  // スライダー
  const mainProductSwiper = new Swiper(".main__product__media .slider", {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 500,
    navigation: {
      nextEl: ".main__product__media .swiper-button-next",
      prevEl: ".main__product__media .swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_header__store"] && !window.DesignMode) return;
  try {
    
  $('.l-header__store__nav__item.l-header__menu').click(
    function(){
    $('.l-header__store').toggleClass('open');
    $('html, body').toggleClass('u-overflow__hidden');
  });
  
  const header = document.querySelector('header');
  let prevY = window.scrollY; 
  
  window.addEventListener('scroll', () => {
    const currentY = window.scrollY; 
    if (currentY < prevY) { 
      header.classList.remove('hide'); 
    } else { 
    if (currentY > 0) { 
        header.classList.add('hide'); 
      }
    }
    prevY = currentY; 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_home__blog"] && !window.DesignMode) return;
  try {
    
  const blogSwiper = new Swiper('.home__blog .swiper', {
    slidesPerGroup: 2,
    slidesPerView: 2,
    spaceBetween: 10,
    grabCursor: true,
    pagination: {
      el: '.home__blog .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.home__blog .swiper-button-next',
      prevEl: '.home__blog .swiper-button-prev',
    },
    breakpoints: {
      960: {
        slidesPerGroup: 2,
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_home__event"] && !window.DesignMode) return;
  try {
    
  const eventSwiper = new Swiper('.home__event .swiper', {
    slidesPerGroup: 2,
    slidesPerView: 2,
    spaceBetween: 10,
    grabCursor: true,
    pagination: {
      el: '.home__event .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.home__event .swiper-button-next',
      prevEl: '.home__event .swiper-button-prev',
    },
    breakpoints: {
      960: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 20,
      }
    },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my_main__visual"] && !window.DesignMode) return;
  try {
    
  const MVswiper = new Swiper(".mv__slider .swiper", {
    loop: true,
    slidesPerView: 2.5,
    spaceBetween: 15,
    speed: 6000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      960: {
        slidesPerView: 5,
        spaceBetween: 20,
      }
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top"] && !window.DesignMode) return;
  try {
    
  const MainVisualSwiper = new Swiper ('.mainvisual .swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  })

  } catch(e) { console.error(e); }
})();
})();
